// Metric event names
export enum MetricEvent {
  AI_TUTOR_CHAT_COMPLETION_FAIL = 'AI_TUTOR_CHAT_COMPLETION_FAIL',
  AI_TUTOR_CHAT_PROFANITY_PII_VIOLATION = 'AI_TUTOR_CHAT_PROFANITY_PII_VIOLATION',
  AI_TUTOR_CHAT_SAVE_FAIL = 'AI_TUTOR_CHAT_SAVE_FAIL',
  AI_TUTOR_CHAT_FETCH_FAIL = 'AI_TUTOR_CHAT_FETCH_FAIL',
  AI_TUTOR_FEEDBACK_SAVE_FAIL = 'AI_TUTOR_FEEDBACK_SAVE_FAIL',
  AI_TUTOR_UPDATE_SECTION_ACCESS_FAIL = 'AI_TUTOR_UPDATE_SECTION_ACCESS_FAIL',
  AI_TUTOR_UPDATE_USER_ACCESS_FAIL = 'AI_TUTOR_UPDATE_USER_ACCESS_FAIL',
  CDO_BLOCKLY_GET_CODE_ERROR = 'CDO_BLOCKLY_GET_CODE_ERROR',
  CDO_BLOCKLY_INITIALIZED = 'CDO_BLOCKLY_INITIALIZED',
  GOOGLE_BLOCKLY_GET_CODE_ERROR = 'BLOCKLY_GET_CODE_ERROR',
  LEVELS_SKILL_DELETE_FAIL = 'LEVELS_SKILL_DELETE_FAIL',
  LEVELS_SKILL_SAVE_FAIL = 'LEVELS_SKILL_SAVE_FAIL',
  SKILL_UPDATE_FAIL = 'SKILL_UPDATE_FAIL',
  SKILL_SAVE_FAIL = 'SKILL_SAVE_FAIL',
  STUDENT_WORK_EVALUATION_SAVE_FAIL = 'STUDENT_WORK_EVALUATION_SAVE_FAIL',
  STUDENT_WORK_EVALUATION_SUMMARY_SAVE_FAIL = 'STUDENT_WORK_EVALUATION_SUMMARY_SAVE_FAIL',
  SUBMISSION_STATUS_UNEXPECTED_ERROR = 'SUBMISSION_STATUS_UNEXPECTED_ERROR',
  SUBMIT_PROJECT_UNEXPECTED_ERROR = 'SUBMIT_PROJECT_UNEXPECTED_ERROR',
  USER_LEVEL_INTERACTION_SAVE_FAIL = 'USER_LEVEL_INTERACTION_SAVE_FAIL',
}
